import { Component, OnInit } from '@angular/core';
import {ShoppingService} from "../../shared/services/shopping.service";

@Component({
  selector: 'cart-widget',
  templateUrl: './cart-widget.component.html',
  styleUrls: ['./cart-widget.component.css']
})
export class CartWidgetComponent implements OnInit {

  constructor(
    private shopping:ShoppingService
  ) { }

  ngOnInit() {
  }

  get total() {
    if (this.shopping.hasItems) {
      return this.shopping.cartTotal;
    }
    return 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/cart-widget/cart-widget.component.ts